import React, { useState } from "react";
import colors from "../../styles/colors";
import { Box, Modal, Typography } from "@mui/material";

interface CirclesProps {
  isAnimatingOut: boolean;
  left: string;
  zIndex: number;
  colorIndex: number; // Add this new prop
  onClick?: () => void;
}

const Circles: React.FC<CirclesProps> = ({ isAnimatingOut, left, zIndex, colorIndex, onClick }) => {
  const commonStyles = {
    position: "absolute" as const,
    left,
  };

  return (
    <>
      <Box
        className={`circle1 ${isAnimatingOut ? "slide-out" : "slide-in"}`}
        onClick={(e: React.MouseEvent<HTMLDivElement>) => e.stopPropagation()} // Prevent event propagation
        sx={{
          ...commonStyles,
          top: "50%",
          zIndex: zIndex - 1,
          backgroundColor: colors.filterColors[colorIndex],
        }}
      />
      <Box
        className={`circle2 ${isAnimatingOut ? "slide-out" : "slide-in"}`}
        onClick={(e: React.MouseEvent<HTMLDivElement>) => {
          e.stopPropagation(); // Prevent event propagation
          onClick?.(); // Call the optional onClick handler if provided
        }}
        sx={{
          ...commonStyles,
          top: "50%",
          zIndex,
          backgroundColor: colors.filterColors[colorIndex],
        }}
        aria-label="Interactive circle"
      />
    </>
  );
};

export default Circles;
